import React from 'react';

import Select from 'react-select';
import 'react-select/dist/react-select.css';
import * as commonApi from '../../../api/common-api';
import axios from 'axios';

var querystring = require('querystring');

class ProfileProject extends React.Component {
    constructor(props) {
        super(props);

        var my = false;
        if (this.props.user.id_account == this.props.profileId) {
            my = true;
        }

        this.state = {
            loading: false,
            profileId: this.props.profileId,
            my: my,
            show: false,
            itemProject: [],
        };
    }

    componentWillMount = () => {
        this.getProject()
    }

    componentDidMount = () => {

    }

    componentWillReceiveProps = (nextProps) => {
		var my = nextProps.my;

        var loading = false;
        if (nextProps.profileId != this.props.profileId) {
            loading = true;
        }
        if (loading) {
            this.setState({loading: loading, profileId: nextProps.profileId, my: my, bio: ""}, () => {
                this.getProject();
            });
        } else {
            this.setState({profileId: nextProps.profileId, my: my});
        }
	}

    getProject = () => {
        this.setState({loading: true});
        var url = "/code/api_projects.php?api=getProjectOfStudent&user_id=" + this.state.profileId
        var data = new FormData();

        axios.post(url, data)
            .then(response => {
                this.setState({loading: false, rst: response.data}, () => {
                    this.renderProject();
                });
            }).catch(error => {
            this.setState({loading: false});
        });
    }

    renderProject = () => {
        let rst = this.state.rst;
        if (rst.results !== undefined) {
            let totalResults = parseInt(rst.totalResults);
            let itemProject = [];

            if (totalResults > 0) {
                var i = 0;
                for (var item of rst.results) {
                    var f_char = item.name_company.substring(0, 1).toUpperCase();
                    if (item.avata != "") {
                        f_char = (<img src={item.avata}/>);
                    }
                    var style = {};
                    if (i == 0) {
                        style = {border: "none"};
                    }
                    var estimateTxt = ''
                    if (item.estimate != null) {
                        estimateTxt = "( " + item.estimate + " hours )"
                    }
                    itemProject.push(
                        <div key={"exp-item-" + item.id_hired}  className="item_box point-cursor" style={style} onClick={this.handleClick.bind(this, "/" + item.link_url + "/" + item.project_id)}>
                            <div className="left_item_box">
                                <div className="image">
                                    {f_char}
                                </div>
                            </div>
                            <div className="right_item_box">
                                <div className="title">{item.enroll_name}</div>
                                <div className="des">{item.name_company}</div>
                                <div className="des">{item.start} - {item.end} {estimateTxt} | {item.location}</div>
                            </div>
                        </div>
                    )
                    i++
                }
            }
            this.setState({itemProject: itemProject});
        }
    }

    handleClick = (act) => {
        window.location = act;
    }

    handleAddlick = () => {
        window.location = "/career-launcher";
    }

    render() {
        if (this.state.itemProject <= 0) {
            return (
                <div> </div>
            );
        }
        return (
            <div className={"page_course_box profile_content_wrapper"} style={{position: 'relative'}}>
                <div className="title_box">
                    <img src="/static/img/appimg/icon_exp.png"/>
                    <div className="title">
                        Projects
                    </div>
                </div>
                <div className={this.state.my ? "add_box clickable" : "hide-el"} onClick={this.handleAddlick.bind(this)}>
                    <div className="left_add_box">
                        <img src="/static/img/appimg/icon_add_black.png"/>
                    </div>
                    <div className="right_add_box">
                        <div className="title">Find Projects</div>
                        <div className="des">
                            <img src="/static/img/appimg/icon_i.png"/> Projects are a new way to build your portfolio on Versity
                        </div>
                    </div>
                </div>
                {this.state.itemProject}
            </div>
        )
    }
}

export default ProfileProject;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_project.js
 **/